import React from 'react'
import { c } from 'ttag'
import { documents } from 'orm'
import ModelForm from 'components/common/Form/ModelForm.js'
import Pane from 'components/common/Pane'
import { detailActionsFactory } from 'components/common/Actions'
const DetailActions = detailActionsFactory(documents)

const t = c('document').t

const fields = [
  {
    name: 'title',
    type: 'text',
    label: t`Title`,
    required: true,
  },
  {
    name: 'description',
    type: 'text',
    label: t`Description`,
    required: false,
  },
]

const EditDocumentForm = ({ pk }) => {
  return (
    <ModelForm
      fields={fields}
      className="modelForm"
      pk={pk}
      model={documents}
    />
  )
}

const DocumentDetail = ({ pk }) => {
  // const item = documents.useItem(pk)
  const item = {}
  return (
    <Pane
      className="Documents"
      title={[t`Documents`, item.subject]}
      actions={<DetailActions pk={pk} />}
    >
      <EditDocumentForm pk={pk} />
    </Pane>
  )
}

export default DocumentDetail
